import 'normalize.css'
import 'focus-visible'
import Vue from 'vue'
import App from './App.vue'
import { i18n } from '@/i18n'
import '@/vee-validate'
import router from './router'
import '@/components/core'
import SocialSharing from 'vue-social-sharing'

Vue.config.productionTip = false

Vue.use(SocialSharing)

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
